import * as React from 'react';
import { useMutation as useMutation$2 } from '@apollo/client';
import { handleError } from './helpers.js';

const useMutation = (mutation, options)=>{
    const [executable, result] = useMutation$2(mutation, options);
    const { error  } = result;
    React.useEffect(()=>{
        if (error) {
            handleError(mutation, error);
        }
    }, [
        error,
        mutation
    ]);
    return [
        executable,
        result
    ];
};
var useMutation$1 = useMutation;

export { useMutation$1 as default };
//# sourceMappingURL=use-mutation.js.map
